
import {globalVar} from 
    "./../../variables/global_variables.js";   

import {checkIfItIsEmpty} from 
    "./../checks/checkIfItIsEmpty.js";

import {getSmetioWikiSmartBox} from 
    "./../get/smetioWiki/getSmetioWikiSmartBox.js";

export function showFormInputExplannation(inputUniqId, formId){
    
    //globalVar["smetioForm_"+formId]["formId"] = formId;
    //globalVar["smetioForm_"+formId]["inputs"] = result["input_details"]; 

    const inputObj = globalVar["smetioForm_"+formId]["inputs"][inputUniqId];

    console.log(inputObj);
    console.log("The input object is like this "+inputObj);

    const explannation = inputObj["inputExplanation"];
    const reasonForDataCollection = inputObj.reasonForDataCollection;
    const howIsDataStored = inputObj.howIsDataStored;
    const whoIsDataSharedWIth = inputObj.whoIsDataSharedWIth;
    const label = inputObj.label;
    const placeholder = inputObj.placeholder;

    if( checkIfItIsEmpty(label) ){

    	label = placeholder;

    };

    /**** 
     * 
     * THE CSS TO THE smetio-input-explannation-box IS LOCATED IN THE smetioSmartBox.scss FILE 
     * 
     * ****/
    const content = `

    	<div class="smetio-input-explannation-box animate__animated animate__fadeInDown">

    		<div class="smetio-input-explannation-box-section">

    			<h2><strong>What is ${label}?</strong></h2>
    			<p>
    				${explannation}
    			</p>

    		</div>

    		<div class="smetio-input-explannation-box-section">

    			<h2><strong>Why is ${label} needed?</strong></h2>
    			<p>
    				${reasonForDataCollection}
    			</p>

    		</div>

    		<div class="smetio-input-explannation-box-section">

    			<h2><strong>How is ${label} stored?</strong></h2>
    			<p>
    				${howIsDataStored}
    			</p>

    		</div>    		

    		<div class="smetio-input-explannation-box-section">

    			<h2><strong>Who is ${label} shared with? </strong></h2>
    			<p>
    				${whoIsDataSharedWIth}
    			</p>

    		</div>   

    	</div>
    `;

    getSmetioWikiSmartBox(content);

    return false;


};